/**
 * generate email link
 * @param  {string} [url='']     url to share
 * @param  {string} [subject=''] subject of the email
 * @return {string}              share string
 */
export default function emailShare(url = '', subject = '') {
  return `mailto:?body=${encodeURIComponent(url)}&subject=${subject}`;
}



// WEBPACK FOOTER //
// ./app/services/share/email.js